// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[4].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[4].use[2]!./personalization.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[4].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[4].use[2]!./advanced-search-general.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[4].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[4].use[2]!./recommendation-personalization.css";
import ___CSS_LOADER_AT_RULE_IMPORT_3___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[4].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[4].use[2]!./theme-settings.css";
import ___CSS_LOADER_AT_RULE_IMPORT_4___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[4].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[4].use[2]!./toast.css";
import ___CSS_LOADER_AT_RULE_IMPORT_5___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[4].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[4].use[2]!./main-menu.css";
import ___CSS_LOADER_AT_RULE_IMPORT_6___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[4].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[4].use[2]!./campaign-popup.css";
import ___CSS_LOADER_AT_RULE_IMPORT_7___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[4].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[4].use[2]!./shopify-integration-settings.css";
import ___CSS_LOADER_AT_RULE_IMPORT_8___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[4].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[4].use[2]!./shopify-integration.css";
import ___CSS_LOADER_AT_RULE_IMPORT_9___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[4].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[4].use[2]!./smart-styling.css";
import ___CSS_LOADER_AT_RULE_IMPORT_10___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[4].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[4].use[2]!./landing-page/ai-powered.css";
import ___CSS_LOADER_AT_RULE_IMPORT_11___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[4].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[4].use[2]!./landing-page/turbo.css";
import ___CSS_LOADER_AT_RULE_IMPORT_12___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[4].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[4].use[2]!./modal.css";
import ___CSS_LOADER_AT_RULE_IMPORT_13___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[4].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[4].use[2]!./banner.css";
import ___CSS_LOADER_AT_RULE_IMPORT_14___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[4].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[4].use[2]!./bundle.css";
import ___CSS_LOADER_AT_RULE_IMPORT_15___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[4].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[4].use[2]!./klaviyo.css";
import ___CSS_LOADER_AT_RULE_IMPORT_16___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[4].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[4].use[2]!./attentive.css";
import ___CSS_LOADER_AT_RULE_IMPORT_17___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[4].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[4].use[2]!./gorgias.css";
import ___CSS_LOADER_AT_RULE_IMPORT_18___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[4].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[4].use[2]!./settings.css";
import ___CSS_LOADER_AT_RULE_IMPORT_19___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[4].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[4].use[2]!./b2b.css";
import ___CSS_LOADER_AT_RULE_IMPORT_20___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[4].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[4].use[2]!./dashboard.css";
import ___CSS_LOADER_AT_RULE_IMPORT_21___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[4].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[4].use[2]!./pre-order-campaign.css";
import ___CSS_LOADER_AT_RULE_IMPORT_22___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[4].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[4].use[2]!./pre-order-notification-settings.css";
import ___CSS_LOADER_AT_RULE_IMPORT_23___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[4].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[4].use[2]!./domain-settings.css";
import ___CSS_LOADER_AT_RULE_IMPORT_24___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[4].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[4].use[2]!./analytics.css";
import ___CSS_LOADER_AT_RULE_IMPORT_25___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[4].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[4].use[2]!./installation.css";
import ___CSS_LOADER_AT_RULE_IMPORT_26___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[4].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[4].use[2]!./back-in-stock.css";
import ___CSS_LOADER_AT_RULE_IMPORT_27___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[4].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[4].use[2]!./ab-testing.css";
import ___CSS_LOADER_AT_RULE_IMPORT_28___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[4].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[4].use[2]!./merchandising.css";
import ___CSS_LOADER_AT_RULE_IMPORT_29___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[4].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[4].use[2]!./onboarding-plan.css";
import ___CSS_LOADER_AT_RULE_IMPORT_30___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[4].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[4].use[2]!./general-swatch.css";
import ___CSS_LOADER_AT_RULE_IMPORT_31___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[4].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[4].use[2]!./integration-details.css";
import ___CSS_LOADER_AT_RULE_IMPORT_32___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[4].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[4].use[2]!./third-party-integration.css";
import ___CSS_LOADER_AT_RULE_IMPORT_33___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[4].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[4].use[2]!./subscription-v5.css";
import ___CSS_LOADER_AT_RULE_IMPORT_34___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[4].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[4].use[2]!./post-purchase.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.cdnfonts.com/css/monaco);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.cdnfonts.com/css/sf-pro-display);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900);"]);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_4___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_5___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_6___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_7___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_8___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_9___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_10___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_11___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_12___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_13___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_14___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_15___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_16___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_17___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_18___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_19___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_20___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_21___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_22___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_23___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_24___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_25___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_26___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_27___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_28___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_29___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_30___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_31___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_32___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_33___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_34___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'SF Pro Text';
  src: url('https://cdn.boostcommerce.io/assets/fonts/SFProText-Regular.ttf') format('truetype');
  font-weight: 400;
  font-style: normal;
}

:root {
  --default: #202223;
  --success: #008060;
  --interactive: #2c6ecb;
  --warning: #916a00;
  --critical: #d72c0d;
}

.text-default {
  color: var(--default);
}

.text-success {
  color: var(--success);
}

.text-interactive {
  color: var(--interactive);
}

.text-warning {
  color: var(--warning);
}

.text-critical {
  color: var(--critical);
}

.text-monaco {
  font-family: 'Monaco';
  font-size: 12px;
}

.text-lowercase {
  text-transform: lowercase;
}

.step-progress-inside-container .progressbar {
  padding: 0;
  margin: 0;
  display: flex;
  list-style-type: none;
  column-gap: 64px;
}

.step-progress-inside-container .progressbar li {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 1px solid #6d7175;
  color: #6d7175;
  font-weight: 500;
  position: relative;
}

.step-progress-inside-container .progressbar li span {
  position: relative;
  top: -1px;
}

.step-progress-inside-container .progressbar li.active,
.step-progress-inside-container .progressbar li.activating {
  background-color: #008060;
  color: #fff;
  border-color: #008060;
}

.step-progress-inside-container .progressbar li~li::before {
  content: '';
  position: absolute;
  border-radius: 1px;
  background: #6d7175;
  width: 58px;
  height: 1px;
  top: 12px;
  right: calc(100% + 3px);
}

.BC-Shopify-Integration-Setup {
  margin: 0 50px 50px 50px;
  background-color: white;
}

.error-container {
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
}

.error-container .title {
  font-size: 20px;
  font-weight: 600;
}

.custom-color-picker {
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0px 2px 10px 0px #0000001a, 0px 0px 2px 0px #00000033;
  background-color: #fff;
  max-width: 264px;
}

.custom-color-picker .custom-pointer {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  box-shadow: rgb(255, 255, 255) 0px 0px 0px 1px inset;
  transform: translate(-6px, -6px);
  border: 2px solid #fff;
}

.custom-color-picker .custom-slider {
  /* width: 8px;
  border-radius: 1px;
  height: 20px;
  box-shadow: 0 0 2px rgba(0, 0, 0, .6);
  background: #fff;
  transform: translate(-4px, 1px); */
  width: 18px;
  height: 18px;
  border-radius: 50%;
  box-shadow: 0px 2px 12px 0px #0000001a, 0px 0px 3px 0px #00000033;
  transform: translate(-9px, 2px);
  background-color: #fff;
}

.custom-color-picker .custom-color-picker__hue,
.custom-color-picker .custom-color-picker__alpha {
  /* height: 24px; */
  position: relative;
  margin: 8px 0px;
  width: 100%;
}

.custom-color-picker .custom-color-picker__hue .hue-horizontal {
  border-radius: 16px !important;
}

.custom-color-picker .alpha-picker>div>div:nth-child(1),
.custom-color-picker .alpha-picker>div>div:nth-child(2) {
  border-radius: 16px !important;
}

.custom-color-picker .custom-color-picker__input {
  margin-top: 16px;
}

.custom-color-picker .custom-color-picker__input .Polaris-Connected>.Polaris-Connected__Item:first-child .Polaris-TextField__Backdrop {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-top-color: var(--p-border-subdued);
  border-right: 0;
}

.custom-color-picker .custom-color-picker__input--disable-alpha .Polaris-Connected>.Polaris-Connected__Item:first-child .Polaris-TextField__Backdrop {
  border-right: 1px solid var(--p-border-subdued);
  border-radius: 4px;
}

.custom-color-picker .custom-color-picker__input-alpha {
  width: 60px;
  height: 36px;
  border: var(--p-border-transparent);
  border: 1px solid #c9cccf;
  margin-left: -4px;
  border-left: 0;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.custom-color-picker .custom-color-picker__input-alpha .Polaris-Connected>.Polaris-Connected__Item:first-child .Polaris-TextField__Backdrop {
  border-radius: 4px;
  border-right: 1px solid var(--p-border-subdued);
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.custom-color-picker .custom-color-picker__input-alpha .Polaris-TextField__Input {
  border: none;
  width: 60px;
  outline: none !important;
  height: 20px;
  padding: 0 13px;
  padding-right: 16px;
  position: relative;
  z-index: 15;
}

.custom-color-picker .custom-color-picker__input-alpha .Polaris-TextField__Spinner {
  display: none;
}

.custom-color-picker .custom-color-picker__input-alpha .Polaris-Connected__Item:last-child {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: -4px;
  z-index: 30;
  position: absolute;
  top: 50%;
  right: 6px;
  transform: translate(0, -55%);
}

.custom-color-picker .hue-picker {
  height: 20px !important;
  width: 100% !important;
}

.custom-color-picker .hue-picker .hue-horizontal>div>div {
  transform: translate(-9px, 0) !important;
}

.custom-color-picker .alpha-picker {
  height: 20px !important;
  width: 100% !important;
}

.custom-color-picker .alpha-picker>div>div:last-child>div>div {
  transform: translate(-9px, 0) !important;
}

.BC-Toggle-Switch-Button {
  display: inline-flex;
  align-items: center;
}

.BC-Toggle-Switch-Button .Polaris-Icon {
  margin: 0;
  width: 16px;
  height: 16px;
}

.BC-Toggle-Switch-Button .Polaris-Icon__Svg path {
  fill: #fff;
}

.BC-Toggle-Switch-Button .BC-Switch-Status {
  position: relative;
  display: inline-block;
  width: 51px;
  min-width: 34px;
  height: 24px;
}

.BC-Toggle-Switch-Button .BC-Switch-Status.BC-Switch-Status--small {
  width: 34px;
  height: 16px;
}

.BC-Toggle-Switch-Button .BC-Switch-Status input {
  opacity: 0;
  width: 0;
  height: 0;
}

.BC-Toggle-Switch-Button .BC-Switch-Status>.BC-Switch-Status__Bar {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 50px;
  background-color: var(--p-surface-neutral);
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.BC-Toggle-Switch-Button .BC-Switch-Status>.BC-Switch-Status__Bar .BC-Switch-Status__Dot {
  position: absolute;
  content: '';
  height: 24px;
  width: 24px;
  left: 0;
  bottom: 0;
  border-radius: 50%;
  background-color: var(--p-icon);
  -webkit-transition: 0.4s;
  transition: 0.4s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.BC-Toggle-Switch-Button .BC-Switch-Status.BC-Switch-Status--small .BC-Switch-Status__Dot {
  height: 16px;
  width: 16px;
}

.BC-Toggle-Switch-Button .BC-Switch-Status input:disabled+.BC-Switch-Status__Bar {
  background-color: var(--p-surface-neutral-disabled);
  cursor: not-allowed;
}

.BC-Toggle-Switch-Button .BC-Switch-Status input:disabled+.BC-Switch-Status__Bar .BC-Switch-Status__Dot {
  background-color: var(--p-icon-disabled);
}

.BC-Toggle-Switch-Button .BC-Switch-Status input:checked+.BC-Switch-Status__Bar {
  background-color: var(--p-surface-success);
}

.BC-Toggle-Switch-Button .BC-Switch-Status input:checked+.BC-Switch-Status__Bar .BC-Switch-Status__Dot {
  background-color: var(--p-border-success);
  left: 2px;
}

.BC-Toggle-Switch-Button .BC-Switch-Status input:focus+.BC-Switch-Status__Bar {
  box-shadow: 0 0 1px var(--p-surface-success-subdued-pressed);
}

.BC-Toggle-Switch-Button .BC-Switch-Status input:checked+.BC-Switch-Status__Bar .BC-Switch-Status__Dot {
  -webkit-transform: translateX(24px);
  -ms-transform: translateX(24px);
  transform: translateX(24px);
}

.BC-Toggle-Switch-Button .BC-Switch-Status.BC-Switch-Status--small input:checked+.BC-Switch-Status__Bar .BC-Switch-Status__Dot {
  -webkit-transform: translateX(16px);
  -ms-transform: translateX(16px);
  transform: translateX(16px);
}

.BC-Toggle-Switch-Button .__react_component_tooltip {
  padding: 4px 8px;
  box-shadow: 0px 2px 10px 0px #0000001a, 0px 0px 2px 0px #00000033;
}

.BC-Toggle-Switch-Button .__react_component_tooltip::after {
  display: none;
}

.BC-Toggle-Switch-Button .Polaris-Labelled__LabelWrapper {
  margin-bottom: 0;
}

.BC-Toggle-Switch-Button .Polaris-Spinner {
  height: 20px;
}

.clickable {
  cursor: pointer;
}

.custom-modal .Polaris-Backdrop {
  z-index: 529;
}

.custom-modal .Polaris-Modal-Dialog__Container {
  z-index: 530;
}

.custom-modal .Polaris-Modal-Dialog__Modal {
  max-width: 816px !important;
}

/* Fullscreen bar  */
/**/
.Polaris-FullscreenBar {
  z-index: 518;
  position: sticky;
  top: 0;
}

.Polaris-FullscreenBar__BackAction :first-child {
  padding-right: unset;
}

.Polaris-FullscreenBar .Polaris-FullscreenBar__BackAction {
  border-right: unset;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
}

.Polaris-FullscreenBar .Polaris-FullscreenBar__BackAction .Polaris-Icon {
  margin-right: 8px;
  fill: #5c5f62;
}

.BC-FullscreenBar .BC-FullscreenBar-Content {
  display: flex;
  flex-grow: 1;
  justify-content: space-between;
  align-items: center;
  padding-left: 1rem;
  padding-right: 1rem;
}

.BC-FullscreenBar .BC-FullscreenBar-Content .BC-FullscreenBar-Content_Title {
  margin: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.BC-FullscreenBar .Polaris-FullscreenBar__BackAction+.BC-FullscreenBar-Content .BC-FullscreenBar-Content_Title {
  margin: 0 auto;
}

.BC-Fullscreen-ProgressBar {
  position: sticky;
  top: 3.5rem;
  z-index: 518;
}

.BC-Fullscreen-ProgressBar .Polaris-ProgressBar--sizeMedium {
  height: 0.25rem;
  border-radius: 0;
}

.btn-actions-warning-setup-live .Polaris-ButtonGroup {
  justify-content: flex-end;
}

.w-full {
  width: 100%;
}

.timer-wrapper {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  position: relative;
}

.timer-wrapper .Polaris-Labelled--hidden {
  position: relative;
  z-index: 5;
  width: 100%;
}

.timer-controller {
  position: absolute;
  right: 4px;
  top: 3px;
  /* transform: translateY(-50%); */
  display: flex;
  flex-direction: column;
  z-index: 10;
  gap: 3px;
}

.timer-controller .Polaris-Button {
  background-color: #E4E5E7;
  padding: 0;
  min-width: 0;
  min-height: 0;
  border: none;
}

.timer-controller .Polaris-Button .Polaris-Button__Content .Polaris-Icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.settings-item .Polaris-TextField__SpinnerIcon,
.timer-controller .Polaris-Button .Polaris-Button__Content .Polaris-Icon__Svg {
  width: 16px;
  height: 16px;
}

.timer-controller .Polaris-Button .Polaris-Button__Content {
  max-width: 20px;
  max-height: 13px;
}

.timer-wrapper .Polaris-TextField {
  padding-right: 28px;
}

.timer-wrapper .Polaris-TextField__Suffix {
  margin-right: 4px;
}`, "",{"version":3,"sources":["webpack://./src/styles/global.css"],"names":[],"mappings":"AAwCA;EACE,0BAA0B;EAC1B,8FAA8F;EAC9F,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,SAAS;EACT,aAAa;EACb,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;;EAEE,yBAAyB;EACzB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,iEAAiE;EACjE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oDAAoD;EACpD,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE;;;;;oCAKkC;EAClC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iEAAiE;EACjE,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,yCAAyC;EACzC,eAAe;AACjB;;AAEA;EACE,+CAA+C;EAC/C,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mCAAmC;EACnC,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,4BAA4B;EAC5B,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,+CAA+C;EAC/C,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,wBAAwB;EACxB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,eAAe;EACf,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,mBAAmB;EACnB,0CAA0C;EAC1C,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,OAAO;EACP,SAAS;EACT,kBAAkB;EAClB,+BAA+B;EAC/B,wBAAwB;EACxB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,mDAAmD;EACnD,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,yCAAyC;EACzC,SAAS;AACX;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,iEAAiE;AACnE;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,oBAAoB;AACpB,GAAG;AACH;EACE,YAAY;EACZ,gBAAgB;EAChB,MAAM;AACR;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,iCAAiC;EACjC,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,UAAU;EACV,YAAY;EACZ,aAAa;EACb,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":["@import url('https://fonts.cdnfonts.com/css/monaco');\n@import url('https://fonts.cdnfonts.com/css/sf-pro-display');\n@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900');\n\n@import url('./personalization.css');\n@import url('./advanced-search-general.css');\n@import url('./recommendation-personalization.css');\n@import url('./theme-settings.css');\n@import url('./toast.css');\n@import url('./main-menu.css');\n@import url('./campaign-popup.css');\n@import url('./shopify-integration-settings.css');\n@import url('./shopify-integration.css');\n@import url('./smart-styling.css');\n@import url('./landing-page/ai-powered.css');\n@import url('./landing-page/turbo.css');\n@import url('./modal.css');\n@import url('./banner.css');\n@import url('./bundle.css');\n@import url('./klaviyo.css');\n@import url('./attentive.css');\n@import url('./gorgias.css');\n@import url('./settings.css');\n@import url('./b2b.css');\n@import url('./dashboard.css');\n@import url('./pre-order-campaign.css');\n@import url('./pre-order-notification-settings.css');\n@import url('./domain-settings.css');\n@import url('./analytics.css');\n@import url('./installation.css');\n@import url('./back-in-stock.css');\n@import url('./ab-testing.css');\n@import url('./merchandising.css');\n@import url('./onboarding-plan.css');\n@import url('./general-swatch.css');\n@import url('./integration-details.css');\n@import url('./third-party-integration.css');\n@import url(\"./subscription-v5.css\");\n@import url(\"./post-purchase.css\");\n\n@font-face {\n  font-family: 'SF Pro Text';\n  src: url('https://cdn.boostcommerce.io/assets/fonts/SFProText-Regular.ttf') format('truetype');\n  font-weight: 400;\n  font-style: normal;\n}\n\n:root {\n  --default: #202223;\n  --success: #008060;\n  --interactive: #2c6ecb;\n  --warning: #916a00;\n  --critical: #d72c0d;\n}\n\n.text-default {\n  color: var(--default);\n}\n\n.text-success {\n  color: var(--success);\n}\n\n.text-interactive {\n  color: var(--interactive);\n}\n\n.text-warning {\n  color: var(--warning);\n}\n\n.text-critical {\n  color: var(--critical);\n}\n\n.text-monaco {\n  font-family: 'Monaco';\n  font-size: 12px;\n}\n\n.text-lowercase {\n  text-transform: lowercase;\n}\n\n.step-progress-inside-container .progressbar {\n  padding: 0;\n  margin: 0;\n  display: flex;\n  list-style-type: none;\n  column-gap: 64px;\n}\n\n.step-progress-inside-container .progressbar li {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  border: 1px solid #6d7175;\n  color: #6d7175;\n  font-weight: 500;\n  position: relative;\n}\n\n.step-progress-inside-container .progressbar li span {\n  position: relative;\n  top: -1px;\n}\n\n.step-progress-inside-container .progressbar li.active,\n.step-progress-inside-container .progressbar li.activating {\n  background-color: #008060;\n  color: #fff;\n  border-color: #008060;\n}\n\n.step-progress-inside-container .progressbar li~li::before {\n  content: '';\n  position: absolute;\n  border-radius: 1px;\n  background: #6d7175;\n  width: 58px;\n  height: 1px;\n  top: 12px;\n  right: calc(100% + 3px);\n}\n\n.BC-Shopify-Integration-Setup {\n  margin: 0 50px 50px 50px;\n  background-color: white;\n}\n\n.error-container {\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 16px;\n}\n\n.error-container .title {\n  font-size: 20px;\n  font-weight: 600;\n}\n\n.custom-color-picker {\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0px 2px 10px 0px #0000001a, 0px 0px 2px 0px #00000033;\n  background-color: #fff;\n  max-width: 264px;\n}\n\n.custom-color-picker .custom-pointer {\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  box-shadow: rgb(255, 255, 255) 0px 0px 0px 1px inset;\n  transform: translate(-6px, -6px);\n  border: 2px solid #fff;\n}\n\n.custom-color-picker .custom-slider {\n  /* width: 8px;\n  border-radius: 1px;\n  height: 20px;\n  box-shadow: 0 0 2px rgba(0, 0, 0, .6);\n  background: #fff;\n  transform: translate(-4px, 1px); */\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  box-shadow: 0px 2px 12px 0px #0000001a, 0px 0px 3px 0px #00000033;\n  transform: translate(-9px, 2px);\n  background-color: #fff;\n}\n\n.custom-color-picker .custom-color-picker__hue,\n.custom-color-picker .custom-color-picker__alpha {\n  /* height: 24px; */\n  position: relative;\n  margin: 8px 0px;\n  width: 100%;\n}\n\n.custom-color-picker .custom-color-picker__hue .hue-horizontal {\n  border-radius: 16px !important;\n}\n\n.custom-color-picker .alpha-picker>div>div:nth-child(1),\n.custom-color-picker .alpha-picker>div>div:nth-child(2) {\n  border-radius: 16px !important;\n}\n\n.custom-color-picker .custom-color-picker__input {\n  margin-top: 16px;\n}\n\n.custom-color-picker .custom-color-picker__input .Polaris-Connected>.Polaris-Connected__Item:first-child .Polaris-TextField__Backdrop {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n  border-top-color: var(--p-border-subdued);\n  border-right: 0;\n}\n\n.custom-color-picker .custom-color-picker__input--disable-alpha .Polaris-Connected>.Polaris-Connected__Item:first-child .Polaris-TextField__Backdrop {\n  border-right: 1px solid var(--p-border-subdued);\n  border-radius: 4px;\n}\n\n.custom-color-picker .custom-color-picker__input-alpha {\n  width: 60px;\n  height: 36px;\n  border: var(--p-border-transparent);\n  border: 1px solid #c9cccf;\n  margin-left: -4px;\n  border-left: 0;\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n}\n\n.custom-color-picker .custom-color-picker__input-alpha .Polaris-Connected>.Polaris-Connected__Item:first-child .Polaris-TextField__Backdrop {\n  border-radius: 4px;\n  border-right: 1px solid var(--p-border-subdued);\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.custom-color-picker .custom-color-picker__input-alpha .Polaris-TextField__Input {\n  border: none;\n  width: 60px;\n  outline: none !important;\n  height: 20px;\n  padding: 0 13px;\n  padding-right: 16px;\n  position: relative;\n  z-index: 15;\n}\n\n.custom-color-picker .custom-color-picker__input-alpha .Polaris-TextField__Spinner {\n  display: none;\n}\n\n.custom-color-picker .custom-color-picker__input-alpha .Polaris-Connected__Item:last-child {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-left: -4px;\n  z-index: 30;\n  position: absolute;\n  top: 50%;\n  right: 6px;\n  transform: translate(0, -55%);\n}\n\n.custom-color-picker .hue-picker {\n  height: 20px !important;\n  width: 100% !important;\n}\n\n.custom-color-picker .hue-picker .hue-horizontal>div>div {\n  transform: translate(-9px, 0) !important;\n}\n\n.custom-color-picker .alpha-picker {\n  height: 20px !important;\n  width: 100% !important;\n}\n\n.custom-color-picker .alpha-picker>div>div:last-child>div>div {\n  transform: translate(-9px, 0) !important;\n}\n\n.BC-Toggle-Switch-Button {\n  display: inline-flex;\n  align-items: center;\n}\n\n.BC-Toggle-Switch-Button .Polaris-Icon {\n  margin: 0;\n  width: 16px;\n  height: 16px;\n}\n\n.BC-Toggle-Switch-Button .Polaris-Icon__Svg path {\n  fill: #fff;\n}\n\n.BC-Toggle-Switch-Button .BC-Switch-Status {\n  position: relative;\n  display: inline-block;\n  width: 51px;\n  min-width: 34px;\n  height: 24px;\n}\n\n.BC-Toggle-Switch-Button .BC-Switch-Status.BC-Switch-Status--small {\n  width: 34px;\n  height: 16px;\n}\n\n.BC-Toggle-Switch-Button .BC-Switch-Status input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.BC-Toggle-Switch-Button .BC-Switch-Status>.BC-Switch-Status__Bar {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border-radius: 50px;\n  background-color: var(--p-surface-neutral);\n  -webkit-transition: 0.4s;\n  transition: 0.4s;\n}\n\n.BC-Toggle-Switch-Button .BC-Switch-Status>.BC-Switch-Status__Bar .BC-Switch-Status__Dot {\n  position: absolute;\n  content: '';\n  height: 24px;\n  width: 24px;\n  left: 0;\n  bottom: 0;\n  border-radius: 50%;\n  background-color: var(--p-icon);\n  -webkit-transition: 0.4s;\n  transition: 0.4s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.BC-Toggle-Switch-Button .BC-Switch-Status.BC-Switch-Status--small .BC-Switch-Status__Dot {\n  height: 16px;\n  width: 16px;\n}\n\n.BC-Toggle-Switch-Button .BC-Switch-Status input:disabled+.BC-Switch-Status__Bar {\n  background-color: var(--p-surface-neutral-disabled);\n  cursor: not-allowed;\n}\n\n.BC-Toggle-Switch-Button .BC-Switch-Status input:disabled+.BC-Switch-Status__Bar .BC-Switch-Status__Dot {\n  background-color: var(--p-icon-disabled);\n}\n\n.BC-Toggle-Switch-Button .BC-Switch-Status input:checked+.BC-Switch-Status__Bar {\n  background-color: var(--p-surface-success);\n}\n\n.BC-Toggle-Switch-Button .BC-Switch-Status input:checked+.BC-Switch-Status__Bar .BC-Switch-Status__Dot {\n  background-color: var(--p-border-success);\n  left: 2px;\n}\n\n.BC-Toggle-Switch-Button .BC-Switch-Status input:focus+.BC-Switch-Status__Bar {\n  box-shadow: 0 0 1px var(--p-surface-success-subdued-pressed);\n}\n\n.BC-Toggle-Switch-Button .BC-Switch-Status input:checked+.BC-Switch-Status__Bar .BC-Switch-Status__Dot {\n  -webkit-transform: translateX(24px);\n  -ms-transform: translateX(24px);\n  transform: translateX(24px);\n}\n\n.BC-Toggle-Switch-Button .BC-Switch-Status.BC-Switch-Status--small input:checked+.BC-Switch-Status__Bar .BC-Switch-Status__Dot {\n  -webkit-transform: translateX(16px);\n  -ms-transform: translateX(16px);\n  transform: translateX(16px);\n}\n\n.BC-Toggle-Switch-Button .__react_component_tooltip {\n  padding: 4px 8px;\n  box-shadow: 0px 2px 10px 0px #0000001a, 0px 0px 2px 0px #00000033;\n}\n\n.BC-Toggle-Switch-Button .__react_component_tooltip::after {\n  display: none;\n}\n\n.BC-Toggle-Switch-Button .Polaris-Labelled__LabelWrapper {\n  margin-bottom: 0;\n}\n\n.BC-Toggle-Switch-Button .Polaris-Spinner {\n  height: 20px;\n}\n\n.clickable {\n  cursor: pointer;\n}\n\n.custom-modal .Polaris-Backdrop {\n  z-index: 529;\n}\n\n.custom-modal .Polaris-Modal-Dialog__Container {\n  z-index: 530;\n}\n\n.custom-modal .Polaris-Modal-Dialog__Modal {\n  max-width: 816px !important;\n}\n\n/* Fullscreen bar  */\n/**/\n.Polaris-FullscreenBar {\n  z-index: 518;\n  position: sticky;\n  top: 0;\n}\n\n.Polaris-FullscreenBar__BackAction :first-child {\n  padding-right: unset;\n}\n\n.Polaris-FullscreenBar .Polaris-FullscreenBar__BackAction {\n  border-right: unset;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n}\n\n.Polaris-FullscreenBar .Polaris-FullscreenBar__BackAction .Polaris-Icon {\n  margin-right: 8px;\n  fill: #5c5f62;\n}\n\n.BC-FullscreenBar .BC-FullscreenBar-Content {\n  display: flex;\n  flex-grow: 1;\n  justify-content: space-between;\n  align-items: center;\n  padding-left: 1rem;\n  padding-right: 1rem;\n}\n\n.BC-FullscreenBar .BC-FullscreenBar-Content .BC-FullscreenBar-Content_Title {\n  margin: 0;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.BC-FullscreenBar .Polaris-FullscreenBar__BackAction+.BC-FullscreenBar-Content .BC-FullscreenBar-Content_Title {\n  margin: 0 auto;\n}\n\n.BC-Fullscreen-ProgressBar {\n  position: sticky;\n  top: 3.5rem;\n  z-index: 518;\n}\n\n.BC-Fullscreen-ProgressBar .Polaris-ProgressBar--sizeMedium {\n  height: 0.25rem;\n  border-radius: 0;\n}\n\n.btn-actions-warning-setup-live .Polaris-ButtonGroup {\n  justify-content: flex-end;\n}\n\n.w-full {\n  width: 100%;\n}\n\n.timer-wrapper {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  position: relative;\n}\n\n.timer-wrapper .Polaris-Labelled--hidden {\n  position: relative;\n  z-index: 5;\n  width: 100%;\n}\n\n.timer-controller {\n  position: absolute;\n  right: 4px;\n  top: 3px;\n  /* transform: translateY(-50%); */\n  display: flex;\n  flex-direction: column;\n  z-index: 10;\n  gap: 3px;\n}\n\n.timer-controller .Polaris-Button {\n  background-color: #E4E5E7;\n  padding: 0;\n  min-width: 0;\n  min-height: 0;\n  border: none;\n}\n\n.timer-controller .Polaris-Button .Polaris-Button__Content .Polaris-Icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.settings-item .Polaris-TextField__SpinnerIcon,\n.timer-controller .Polaris-Button .Polaris-Button__Content .Polaris-Icon__Svg {\n  width: 16px;\n  height: 16px;\n}\n\n.timer-controller .Polaris-Button .Polaris-Button__Content {\n  max-width: 20px;\n  max-height: 13px;\n}\n\n.timer-wrapper .Polaris-TextField {\n  padding-right: 28px;\n}\n\n.timer-wrapper .Polaris-TextField__Suffix {\n  margin-right: 4px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
